var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("div", { staticClass: "flex" }, [
        _c("div", { staticClass: "flex-left" }, [
          _c(
            "div",
            { staticClass: "tree-box" },
            [
              _c("BjDivider", { attrs: { "right-fixed": "" } }, [
                _vm._v(_vm._s(_vm.$t("billingPage.BillingCostItem"))),
              ]),
              _c("el-tree", {
                attrs: {
                  data: _vm.treeData,
                  "node-key": "id",
                  "highlight-current": true,
                  "expand-on-click-node": false,
                  "default-expanded-keys": ["1"],
                },
                on: { "node-click": _vm.handleNodeClick },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c("span", { staticClass: "custom-tree-node" }, [
                        _c("span", [_vm._v(_vm._s(node.label))]),
                        _c(
                          "span",
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-plus",
                                type: "text",
                                size: "mini",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.append(data)
                                },
                              },
                            }),
                            _c("el-button", {
                              attrs: {
                                disabled:
                                  data.label == "Category" ||
                                  data.children.length > 0,
                                icon: "el-icon-minus",
                                type: "text",
                                size: "mini",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.remove(node, data)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "flex-right" },
          [
            _c("BjPage", {
              ref: "BjPage",
              attrs: {
                "get-action": _vm.queryApi,
                "query-params": _vm.queryParams,
                "col-span": _vm.colSpan,
                serial: _vm.serial,
                "search-btn-hide": true,
              },
              on: {
                showSetting: _vm.SortableTable.show,
                "header-dragend": _vm.SortableTable.handleHeaderDragend,
                "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
              },
              scopedSlots: _vm._u([
                {
                  key: "tableColumn",
                  fn: function () {
                    return [
                      _vm._l(_vm.dropCols, function (col, index) {
                        return [
                          col.prop !== "bjTableAction"
                            ? _c("el-table-column", {
                                key:
                                  "col_" +
                                  index +
                                  "_" +
                                  col.prop +
                                  "_" +
                                  (col.width || "auto"),
                                attrs: {
                                  prop: col.prop,
                                  label: col.label,
                                  "min-width": col.width || "auto",
                                  fixed: col.fixed || false,
                                  align: "center",
                                  "class-name": "item",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          false
                                            ? void 0
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("timezoneFilters")(
                                                      scope.row[col.prop],
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                ),
                                              ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _vm._e(),
                          col.prop === "bjTableAction"
                            ? _c("el-table-column", {
                                key:
                                  "col_" +
                                  index +
                                  "_" +
                                  col.prop +
                                  "_" +
                                  (col.width || "auto"),
                                attrs: {
                                  prop: col.prop,
                                  label: col.label,
                                  "min-width": col.width || "auto",
                                  fixed: col.fixed || "right",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "edit-btn",
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onEdit(scope.row)
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.$t("editText")))]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "delete-btn",
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDel(scope.row)
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.$t("delText")))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _vm._e(),
                        ]
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogFormVisible,
            width: "450px",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.expenseItem"),
                        prop: "item",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          placeholder: _vm.$t("billingPage.expenseItem"),
                        },
                        model: {
                          value: _vm.form.item,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "item", $$v)
                          },
                          expression: "form.item",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.expenseCategory"),
                        prop: "category",
                      },
                    },
                    [
                      _c("el-cascader", {
                        ref: "cascader4",
                        staticStyle: { width: "100%" },
                        attrs: {
                          options: _vm.CategoryList,
                          placeholder: _vm.$t("billingPage.expenseCategory"),
                          filterable: "",
                          clearable: "",
                          "show-all-levels": false,
                          props: { expandTrigger: "hover" },
                        },
                        on: { change: _vm.costCategoryFormChange },
                        model: {
                          value: _vm.form.category,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "category", $$v)
                          },
                          expression: "form.category",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.description"),
                        prop: "description",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          placeholder: _vm.$t("billingPage.description"),
                        },
                        model: {
                          value: _vm.form.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "description", $$v)
                          },
                          expression: "form.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onSave()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }